// extracted by mini-css-extract-plugin
export default {"tagBlock":"StatusBar_tagBlock__d4ZPE"};